import axios from 'axios';
import { auth } from '../firebase';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001/api/v2',
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 10000 // 10 second timeout
});

// Add auth token to requests
api.interceptors.request.use(async (config) => {
  try {
    const user = auth.currentUser;
    if (user) {
      const token = await user.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  } catch (error) {
    console.warn('Error getting auth token:', error);
    return config; // Continue without token rather than failing
  }
});

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Don't redirect to login for profile fetch failures
    // The AuthContext will handle those gracefully
    if (error.response?.status === 401 && !error.config?.url?.includes('/auth/me')) {
      // Only redirect for non-profile requests
      console.warn('Unauthorized request, redirecting to login');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;